import React, { useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Button} from '@mui/material';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL';
import MemberDataPage from '../Contents/Member/MemberDataPage';
import '../Contents/IDCard/CardStudio.css';
import IDCardShow from '../Contents/IDCard/IDCardShow';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const IDCard = () => {




  const [CountData,setCountData] = useState(null)
  const [Token,setToken] = useState(null)
  const {setLoader,accesstoken,RefreshUesFF,Person,Refresh,setRefresh,MemberDataIDCard,setMemberDataIDCard} = useContext(ContextData)


  useEffect(()=>{setRefresh(!Refresh)},[])

    useEffect(() =>{


      async function FetchData(){
        //  setLoader(true)

      try {
        const response = await axios.get(`${baseUrl}/auth/get_data_member_user/${Person.acc_level}`,{
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            'authorization': `Bearer ${accesstoken !== null && accesstoken}`
          }})


        setMemberDataIDCard(response.data)

        setCountData(response.data.length)
        setLoader(false)

      } catch (err) {
         if(err) console.log(err.message)
        // setLoader(false)
      }


}FetchData()




    },[Refresh])

    const filteredMembers = useMemo(() => {
      return MemberDataIDCard ? MemberDataIDCard.filter(list => list.acc_status === 3 && list.id_card_status === "0") : [];
    }, [MemberDataIDCard,Refresh]);

    const count = filteredMembers.length;

    const GetTokens = (token)=>{

      setToken(token)
     // alert(token)
     // console.log(Token)

    }

    const PrintFunc = ()=>{

          window.print()
    }


  return (
    <div className="fin-id-workspace"><div className="fin-id-layout">
      <aside className="fin-id-member-list hide-at-prnt" aria-label="Members awaiting identity cards">
        <div className="fin-id-list-heading"><h2>Member queue</h2><p>{count} members ready for card preparation</p></div>
        {MemberDataIDCard === null ? <p className="fin-card-help">Loading members…</p> : <ul>{MemberDataIDCard.filter(list => list.acc_status === 3 && list.id_card_status === "0").map((list,index) => <li key={list.token} className={`fin-id-member-row ${Token === list.token ? 'is-selected' : ''}`}><button onClick={() => GetTokens(list.token)} aria-pressed={Token === list.token}><span aria-hidden="true">{String(index + 1).padStart(2,'0')}</span><span><strong>{list.fname} {list.lname}</strong><small>{list.stateoforigin || 'Member'} · Ready to prepare</small></span></button></li>)}</ul>}
      </aside>
      <div className="fin-id-main">
        <header className="fin-id-page-heading hide-at-prnt"><div><h2>Identity card studio</h2><p>Review member information and prepare a clear, consistent membership card.</p></div><div className="fin-id-page-actions"><Button onClick={PrintFunc} variant="contained">Print card</Button></div></header>
        <ol className="fin-id-steps hide-at-prnt"><li><span>1</span>Select a member</li><li><span>2</span>Review & save details</li><li><span>3</span>Print & complete</li></ol>
        <div className="fin-id-studios"><IDCardShow token={Token !== null && Token} /></div>
      </div>
    </div></div>
  );
};
export default IDCard;
